export const CIL_POINTS_LABEL = 'CIL Points';

/** Es. "120 CIL Points" */
export const formatCilPoints = (amount) => {
  const n = Number(amount);
  if (Number.isNaN(n)) return `0 ${CIL_POINTS_LABEL}`;
  return `${n} ${CIL_POINTS_LABEL}`;
};
